import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-LO-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 89 30.14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-LO-logo_svg__cls-1{fill:#252668;fill-rule:evenodd}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m37.94 16.14 3.49-7a1.32 1.32 0 0 1 .54 1.84l-3 5 1.01-.16c.05 0 .11-.01.16-.01.57 0 1.02.46 1.02 1.03h2.83l-.25-.32h-.52l-.11-.16h1.5c.17.28.46.46.78.48-.02.05-.03.1-.05.16h-6.35l2.63 2.02c.3.23.48.59.47.97 0 .33-.13.65-.36.88L37.79 17h-4.36c-.02-.05-.03-.1-.05-.16l4.55-.7",
      class: "svg-LO-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M33.13 15.07c0-3.46 2.8-6.26 6.26-6.26s6.26 2.8 6.26 6.26-2.8 6.26-6.26 6.26-6.26-2.8-6.26-6.26Zm-19.51 5.55h10.25a10.643 10.643 0 0 1-1.53-5.55C22.34 6.75 29.08 0 37.41 0H89l-2.66 9.52H76.16l-5.84 20.61H59.36L65.2 9.52H54.92c1.01 1.68 1.54 3.59 1.53 5.55 0 8.32-6.75 15.07-15.07 15.07H0L8.51 0h10.95l-5.84 20.62",
      class: "svg-LO-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LO-logo"}) } }